<template>
  <layout width="420">
    <template slot="header">
      Alarms
    </template>
    <template>
      <v-form>
        <object-item-alarms
          v-model="state"
          :type="itemType"
          :object-item-type="objectItemTypes.monitoringItem"
        />
        <form-subheader title="Options" />
        <v-combobox v-model="state.tags" label="Optional tags" multiple chips />
        <form-switcher
          v-model="state.repeat.enabled"
          title="Repeat notification by timer"
        />
        <div v-if="state.repeat.enabled" class="d-flex flex-nowrap">
          <v-text-field
            :value="state.repeat.value"
            class="mr-4"
            @input="state.repeat.value = Number($event)"
          />
          <v-select v-model="state.repeat.units" :items="['minutes']" />
        </div>
      </v-form>
    </template>
    <template slot="footer">
      <v-spacer />
      <v-btn text color="text-primary" @click.stop="$emit('close')">
        Cancel
      </v-btn>
      <v-btn
        text
        color="primary"
        depressed
        :loading="loading"
        @click.stop="submit"
      >
        Save
      </v-btn>
    </template>
  </layout>
</template>

<script>
import { ref, onBeforeMount, computed } from '@vue/composition-api';
import { usePromise } from 'vue-composable';
import { schemasService } from '@/modules/common/api';
import { prepareObject } from '@/provider/utils';
import ObjectItemAlarms from '@/modules/objects/ui/object-card/general/ObjectItemAlarms.vue';
import Layout from '@/components/popup/PopupLayoutDefault';
import { monitoringItemService } from '@/modules/object-types/api';
import {
  defaultMonitoringAlarm,
  defaultMonitoringRepeat
} from '@/modules/objects/ui/object-card/general/item-helpers';
import { objectItemTypes } from '@/modules/objects/ui/object-card/general/item-helpers';

export default {
  name: 'MonitoringItemAlarmsDefaultEdit',
  components: {
    ObjectItemAlarms,
    Layout
  },
  props: {
    monitoringItemId: {
      type: String,
      default: ''
    }
  },
  setup(props, { emit }) {
    const state = ref({
      tags: [],
      repeat: defaultMonitoringRepeat(),
      alarms: []
    });
    const monitoringItem = ref({});

    const handleSubmit = async () => {
      await schemasService.updateValues(
        [
          {
            id: monitoringItem.value.stateAlarms.id,
            value: state.value.alarms
          },
          {
            id: monitoringItem.value.stateTags.id,
            value: state.value.tags
          },
          {
            id: monitoringItem.value.stateRepeat?.id,
            value: state.value.repeat
          }
        ],
        props.monitoringItemId,
        false
      );
      emit('close');
    };

    const { loading, exec: submit } = usePromise(handleSubmit, true);

    onBeforeMount(async () => {
      monitoringItem.value = prepareObject(
        await monitoringItemService.fetch(props.monitoringItemId)
      );
      const alarmCount = monitoringItem.value.commonAlertCount.value;
      for (let i = 0; i < alarmCount; i++) {
        state.value.alarms.push({
          ...defaultMonitoringAlarm(),
          ...(monitoringItem.value.stateAlarms?.value?.[i] || {})
        });
      }
      state.value.tags = monitoringItem.value.stateTags.value || [];
      state.value.repeat = {
        ...(monitoringItem.value.stateRepeat?.value ||
          defaultMonitoringRepeat())
      };
    });

    const itemType = computed(() => monitoringItem.value?.commonType?.value);

    return {
      state,
      loading,
      submit,
      itemType,
      objectItemTypes
    };
  }
};
</script>
